import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {_imagenLogo} from '../../imagenesBase64/logo'
import Swal from 'sweetalert2';
import {transformarIso8601,fechaActual} from '../../Helpers/fechas';
import {formatearMontoMoneda} from '../../Helpers/utilidades-globales'

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const allMonths = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

export function imprimir(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion,parametros){
    try{

        Swal.fire({
            html: 'Buscando...',
            timer: 600,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        }).then(data=>{
            generarDocumento(datos, nombrePDF, tituloPDF,callbackMap,arrayCampos,orientacion ? orientacion : 'portrait',parametros)
        })
    }catch(err){

            const mensaje_html = `<p>Hubo un error al generar el documento</p><p>${err}</p>`

            Swal.fire({
                html:mensaje_html,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })
        }
}

function generarDocumento(
    datos,
    nombrePDF,
    tituloPDF,
    orientacion = 'portrait',
    parametros
  ) {
    // 1) Definimos las 4 columnas fijas y su prefijo en d.fondo
    const columnDefs = [
      { prefix: '1.', label: 'SEDE CENTRAL'    },
      { prefix: '2.', label: 'REGIONES'        },
      { prefix: '3.', label: 'COMPENSATORIO'   },
      { prefix: '4.', label: 'IBR'             },
    ];
  
    // 2) Extraemos el porcentaje para cada columna buscando el primer d.fondo que empiece con ese prefijo
    const pctMap = {
      'SEDE CENTRAL': '40%',
      'REGIONES': '30%'
    };
    columnDefs.forEach(def => {
      const found = datos.find(d => d.fondo.startsWith(def.prefix));
      if (!pctMap[def.label]) {
        pctMap[def.label] = found ? `${Math.round(found.porcentaje * 100)}%` : '';
      }
    });
  
    // 3) Todos los rubros únicos
    const todosLosRubros = Array.from(new Set(datos.map(d => d.rubro))).sort();

    // 3.1) Principales: los que empiezan con "Fondo Central - Diezmos Región"
    const rubrosPrincipales = todosLosRubros
      .filter(r => r.startsWith('Fondo Central - Diezmos Región'))
      .sort();

    // 3.2) Extras: todos los demás (incluye transito, antorcha…)
    const rubrosExtras = todosLosRubros
      .filter(r => !r.startsWith('Fondo Central - Diezmos Región'))
      .sort();
  
    // 4) Construimos el body de la tabla
    const body = [];

    // 4.1) Fila 1 de encabezado
    body.push([
      { text: 'Origen de Ingreso', bold: true, fontSize: 9, rowSpan: 3, margin: [0,6,0,6] },
      { text: 'Distribución de Fondos', bold: true, fontSize: 9, alignment: 'center', colSpan: 4, margin: [0,6,0,6] },
      {},{},{}
    ]);
  
    // 4.2) Fila 2: etiquetas fijas
    body.push([
      {},
      ...columnDefs.map(def => ({
        text: def.label,
        bold: true,
        fontSize: 8,
        alignment: 'center',
        margin: [0,4,0,2]
      }))
    ]);
  
    // 4.3) Fila 3: porcentajes dinámicos
    body.push([
      {},
      ...columnDefs.map(def => ({
        text: pctMap[def.label],
        italics: true,
        fontSize: 7,
        alignment: 'center',
        margin: [0,0,0,6]
      }))
    ]);
  
    // 4.4’) Filas de los rubros principales
    rubrosPrincipales.forEach(rubro => {
      const row = [{ text: rubro, fontSize: 8, margin: [0,2,0,2] }];
      columnDefs.forEach(def => {
        const suma = datos
          .filter(d => d.rubro === rubro && d.fondo.startsWith(def.prefix))
          .reduce((s, x) => s + parseFloat(x.monto_distr || 0), 0);
        row.push({
          text: formatearMontoMoneda(suma),
          fontSize: 8,
          alignment: 'right',
          margin: [0,2,0,2]
        });
      });
      body.push(row);
    });

    // 4.5’) Subtotales de SOLO los rubros principales
    const subtotalRow = [{ text: 'Subtotales', bold: true, fontSize: 9, margin: [0,2,0,2] }];
    columnDefs.forEach(def => {
      const suma = datos
        .filter(d =>
          d.fondo.startsWith(def.prefix) &&
          rubrosPrincipales.includes(d.rubro)
        )
        .reduce((s, x) => s + parseFloat(x.monto_distr || 0), 0);
      subtotalRow.push({
        text: formatearMontoMoneda(suma),
        bold: true,
        fontSize: 8,
        alignment: 'right',
        margin: [0,2,0,2]
      });
    });
    body.push(subtotalRow);

    // 4.6’) Ahora los rubros extras (p.ej. transito, antorcha…)
    rubrosExtras.forEach(rubro => {
      const row = [{ text: rubro, fontSize: 8, margin: [0,2,0,2] }];
      columnDefs.forEach(def => {
        const suma = datos
          .filter(d => d.rubro === rubro && d.fondo.startsWith(def.prefix))
          .reduce((s, x) => s + parseFloat(x.monto_distr || 0), 0);
        row.push({
          text: formatearMontoMoneda(suma),
          fontSize: 8,
          alignment: 'right',
          margin: [0,2,0,2]
        });
      });
      body.push(row);
    });

    // 4.7’) Fondo Central - Varios (igual que antes)
    if (datos.some(d => d.fondo.includes('Fondo Central - Varios'))) {
      const v = datos
        .filter(d => d.fondo.includes('Fondo Central - Varios'))
        .reduce((s, x) => s + parseFloat(x.monto_distr || 0), 0);
      body.push([
        { text: 'Fondo Central - Varios', italics: true, fontSize: 8 },
        { text: formatearMontoMoneda(v), fontSize: 8, alignment: 'right' },
        {},{},{}
      ]);
    }

    // 4.8’) FET - Devolución de préstamos
    if (datos.some(d => d.fondo.includes('Devolución de préstamos'))) {
      const f = datos
        .filter(d => d.fondo.includes('Devolución de préstamos'))
        .reduce((s, x) => s + parseFloat(x.monto_distr || 0), 0);
      body.push([
        { text: 'FET - Devolución de préstamos', italics: true, fontSize: 8 },
        {},{},{},
        { text: formatearMontoMoneda(f), fontSize: 8, alignment: 'right' }
      ]);
    }
  
    // 4.8) Totales por Fondos
    const totalFondosRow = [{ text: 'Totales por Fondos', bold: true, fontSize: 9, margin: [0,2,0,2] }];
    columnDefs.forEach(def => {
      const suma = datos
        .filter(d => d.fondo.startsWith(def.prefix))
        .reduce((s, x) => s + (parseFloat(x.monto_distr) || 0), 0);
      totalFondosRow.push({
        text: formatearMontoMoneda(suma),
        bold: true,
        fontSize: 8,
        alignment: 'right'
      });
    });
    body.push(totalFondosRow);
  
    // 5) Total del período
    const totalPeriodo = datos.reduce((s, x) => s + (parseFloat(x.monto_distr) || 0), 0);
  
    // 6) DocDefinition con los mismos márgenes
    const docDefinition = {
      pageOrientation: orientacion,
      pageMargins: [25, 110, 25, 50],
  
      header: (currentPage, pageCount, pageSize) => {
        if (currentPage === 1) {
          return [
            // Fila del logo y del título principal
            {
              columns: [
                { image: _imagenLogo, width: 50 },
                {
                  text: 'Unión de las Asambleas de Dios - Ingresos integrales Fondos Distribuidos',
                  margin: [10, 0, 0, 0],  // entre logo y texto
                  fontSize: 11
                }
              ],
              // margin: [left, top, right, bottom]
              margin: [25, 20, 25, 0]
            },
      
            // Fila de Mes/Año
            {
              text: tituloPDF,
              fontSize: 9,
              margin: [25, 6, 25, 6]
            },
      
            // Línea divisoria
            {
              canvas: [
                {
                  type: 'line',
                  x1: 0, y1: 4,
                  x2: pageSize.width - 50,  // descontamos márgen derecho
                  y2: 4,
                  lineWidth: 1
                }
              ],
              margin: [25, 0, 25, 0]
            }
          ];
        }
      
        // Páginas posteriores: solo la línea con márgenes
        return {
          canvas: [
            {
              type: 'line',
              x1: 0,   y1: 2,
              x2: pageSize.width - 50,
              y2: 2,
              lineWidth: 0.5
            }
          ],
          margin: [25, 0, 25, 0]
        };
      },
  
      footer: (currentPage, pageCount) => ({
        margin: [25,0,25,20],
        columns: [
          { text: fechaActual('DD/MM/YYYY'), alignment:'left', fontSize:8 },
          { text: `Página ${currentPage} de ${pageCount}`, alignment:'right', fontSize:8 }
        ]
      }),
  
      content: [
        {
          style: 'reportTable',
          table: {
            headerRows: 3,
            widths: ['*',80,80,80,80],
            body
          },
          layout: {
            hLineWidth: i => i<3 ? 1 : 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#000',
            vLineColor: () => '#ddd',
            fillColor: r => r<3 ? '#f5f5f5' : null
          }
        },
        {
          text: `Total del Período: ${formatearMontoMoneda(totalPeriodo)}`,
          bold:true,
          alignment:'right',
          margin:[0,8,0,0],
          fontSize:9
        }
      ],
  
      styles: {
        reportTable: { fontSize:8, margin:[0,4,0,4] }
      }
    };
  
    // 7) Abrir el PDF
    pdfMake.createPdf(docDefinition).open();
  }
  
  
  

